import React from 'react';
import classNames from 'classnames';
import { MenuItem } from '@headlessui/react';

export default function StackedListMenuItem({ onClick, children, variant = 'default', disabled = false }) {
  const variantClasses = variant === 'danger'
    ? 'text-red-400 data-[focus]:bg-gray-700 data-[focus]:text-red-300'
    : 'text-gray-300 data-[focus]:bg-gray-700 data-[focus]:text-white';

  return (
    <MenuItem>
      <button
        onClick={onClick}
        disabled={disabled}
        className={classNames(
          'block w-full px-3 py-1 text-left text-sm leading-6',
          disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
          variantClasses
        )}
      >
        {children}
      </button>
    </MenuItem>
  );
}
